exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap);", ""]);

// module
exports.push([module.id, ".v-pagination__item[data-v-d3289d04],.v-pagination__item--active[data-v-d3289d04],.v-pagination__navigation[data-v-d3289d04]{box-shadow:0 1px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 2px 0 rgba(0,0,0,.12)}.v-icon .v-list-item__title[data-v-d3289d04],.v-list-item .v-list-item__title[data-v-d3289d04]{font-weight:400}", ""]);

// exports
